<script setup lang="ts">
type Props = {
  disabled?: boolean;
  active?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  active: false,
  disabled: false,
});

const internalIsHovered = ref<boolean>(false);

const stateClasses = computed(() => {
  if (!props.disabled && (props.active || internalIsHovered.value)) {
    return 'bg-primary text-white';
  }

  if (props.disabled) {
    return 'bg-gray-10 outline outline-1';
  }

  return 'bg-gray-20';
});
</script>

<template>
  <button
    :class="[stateClasses, { 'opacity-60 hover:cursor-default': props.disabled }]"
    class="size-11 rounded transition-colors duration-200 enabled:hover:text-white"
    :disabled="disabled"
    @mouseenter="internalIsHovered = true"
    @mouseleave="internalIsHovered = false"
  >
    <slot></slot>
  </button>
</template>
